import { define, is, nullable, optional, string } from '@subaio/validation'

import type { DefaultFields } from './DefaultProps'

export const fieldString = ({
	requiredErrorMessage = 'This field is required',
	invalidErrorMessage = 'Has to be a string',
}: DefaultFields = {}) =>
	define<string>('fieldString', (value) => {
		const isValidString = is(value, optional(string()))
		if (!isValidString) return invalidErrorMessage
		if (is(value, string())) return true
		return requiredErrorMessage
	})

export const fieldStringOptional = ({
	invalidErrorMessage = 'Has to be a string',
}: Pick<DefaultFields, 'invalidErrorMessage'> = {}) =>
	define<string | undefined | null>(
		'fieldStringOptional',
		(value) => is(value, optional(nullable(string()))) || invalidErrorMessage,
	)
